import React from "react";
import Icon from "js/react/components/Icon";
import { themeColors } from "js/react/sharedStyles";

export default function Avatar({ url, onClick, id }) {
    return (
        <div id={id} className="avatar" onClick={onClick}>
            {url ? <img src={url} /> : <Icon iconName="person" />}
        </div>
    );
}

export function FolderAvatar({ url }) {
    return (
        <div className="avatar" style={{ background: "none", color: themeColors.ui_blue }}>
            {url ? <img src={url} /> : <Icon iconName="folder" />}
        </div>
    );
}

export function TeamAvatar({ url }) {
    return (
        <div className="avatar" style={{ background: "none", color: themeColors.ui_blue }}>
            {url ? <img src={url} /> : <Icon iconName="business" />}
        </div>
    );
}

export function Profile({ profile }) {
    const { photoURL, displayName, email, onClick } = profile;
    return (
        <div className="profile" onClick={onClick}>
            <Avatar url={photoURL} />
            <div className={displayName ? "name-email" : "email-only"}>
                { displayName
                    ? (<><div className="name">{displayName}</div><div className="email">{email}</div></>)
                    : <div className="email">{email}</div>
                }
            </div>
        </div>
    );
}
